import { logger } from '@/lib/logger';

const STORAGE_KEY_PREFIX = 'ahoy-nav-collapsed-';

function getStorageKey(orgId: string): string {
  return `${STORAGE_KEY_PREFIX}${orgId}`;
}

export function getNavCollapsed(orgId: string | undefined): boolean {
  if (!orgId) {
    return false;
  }

  try {
    const raw = localStorage.getItem(getStorageKey(orgId));
    if (!raw) {
      return false;
    }
    const parsed = JSON.parse(raw);
    return parsed === true;
  } catch (err) {
    logger.warn('Failed to read nav collapsed state from localStorage', {
      component: 'nav-collapsed-state',
      error: String(err),
    });
    return false;
  }
}

export function setNavCollapsed(orgId: string, collapsed: boolean): void {
  try {
    localStorage.setItem(getStorageKey(orgId), JSON.stringify(collapsed));
  } catch (err) {
    logger.warn('Failed to persist nav collapsed state to localStorage', {
      component: 'nav-collapsed-state',
      error: String(err),
    });
  }
}
